export class ProductSettlementFinanceGroupsDto {
  buyerGroup: string;
  itemGroup: string;
  inventoryModelGroup: string;
  dimensionGroup: string;
  itemPriceToleranceGroup: string;

  constructor(d?: ProductSettlementFinanceGroupsDto) {
    Object.assign(this, d || {});
  }
}
